module.exports = __webpack_public_path__ + "static/media/revlon.4bcdcd72.jpg";